<template>
  <ul class="jobs-list">
    <li v-if="jobs.length < 40">Loading...</li>
    <li v-for="job in jobs" :key="job.url">
      <a
        @click="$emit('update:selectedJob', job)"
        style="display: flex; justify-content:space-between; width: 100%;"
      >
        <span style="font-weight: 500; flex: 1;">
          {{
            job.normalizedTitle.includes(" ") ? job.normalizedTitle : job.title
          }}
        </span>
        <span style="text-align:right;">{{ job.company.company }} </span>
        <br />
      </a>
      <!-- 
          <a
        @click="
          $emit(
            'update:selectedJob',
            (job.jobs || []).length > 1 ? '' : job.jobs[0] || job
          )
        "
        >{{ job.title }}
        <span v-if="(job.jobs || []).length > 1">({{ job.jobs.length }})</span>
        <br />
      </a>
      <ul v-if="(job.jobs || []).length > 1">
        <li v-for="(j, i) in job.jobs" :key="i">
          <a @click="$emit('update:selectedJob', j)"
            >{{ j.title }}
            <br />
          </a>
        </li>
      </ul>
       -->
    </li>
  </ul>
</template>

<script>
export default {
  name: "JobList",
  props: {
    jobs: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedJob: {
      type: Object,
      required: false,
      default: null,
    },
  },
};
</script>

<style>
ul.jobs-list {
  padding: 0;
  list-style: none;
  max-height: 30rem;
  overflow: scroll;
  scroll-snap-type: y mandatory;
}

ul.jobs-list li ul {
  padding-left: 0.8rem;
}

ul.jobs-list li ul li {
  font-size: 0.7rem;
}

ul.jobs-list li {
  cursor: pointer;
  scroll-snap-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.9rem;
  /* border-bottom: 1px solid lightgray; */
}

ul.jobs-list li a {
  padding: 0.34rem 0rem;
}

ul.jobs-list li a:hover {
  color: rgb(50, 116, 181);
}
</style>
